import {
  select,
  fork,
  put,
  all,
  call,
  take,
  takeLatest,
  takeEvery,
  cancelled,
} from 'redux-saga/effects'

import {
  MOUNT,
  UNMOUNT,
  SUBMIT
} from './constants'

import {
  POST_CANCEL_PROJECT_SUCCESS,
  POST_CANCEL_PROJECT_ERROR,
} from 'containers/Project/View/constants'

import {
  updateActive,
  unmount as closeDialog
} from './actions'

import {
  redirect
} from 'containers/Redirect/actions'

import {
  postCancelProject,
} from 'containers/Project/View/actions'

function* clear() {
  yield put(updateActive(false))
}

function* handleMount(action) {
  yield put(updateActive(true))
}

function* handleUnmount(action) {
  yield fork(clear)
}

function* handleSubmit() {
  yield put(postCancelProject())
  yield take([
    POST_CANCEL_PROJECT_SUCCESS,
    POST_CANCEL_PROJECT_ERROR,
  ])
  yield put(closeDialog())
  yield put(redirect('/project/search'))
}

function* mount() {
  yield takeEvery(MOUNT, handleMount)
}

function* unmount() {
  yield takeEvery(UNMOUNT, handleUnmount)
}

function* watchSubmit() {
  yield takeLatest(SUBMIT, handleSubmit)
}

function* loadSagas() {
  yield all([
    fork(mount),
    fork(unmount),
    fork(watchSubmit)
  ])
}

export default loadSagas
